<div fxLayout="row" fxLayoutAlign="center center" style="height: 200px">
    <span class="subtitle-1">There is no data</span>
</div>
